export default {
    changelogOpen: false,
    logs: [],
    classifications: [],
    requestTypes: [],
    items: [],
    modal: {
        isOpen: false,
        data: {
            name: '',
        },
        errors: {},
    },
    errors: {},
};
